import axios from 'axios';
import BaseAPI from './base/base-api';

class ConfirmBusinessAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'confirmBusiness';
}

export default new ConfirmBusinessAPI();